import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigureDataComponent } from './configure-data.component';
import { SharedUiModule } from '@emi/shared/ui';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
    imports: [
        CommonModule,
        SharedUiModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
    ],
    declarations: [ConfigureDataComponent],
    exports: [ConfigureDataComponent],
})
export class SharedFeatureConfigureDataModule {}
